import React from "react";
import { Box } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const DarkBar = ({ text }) => (
  <Box
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
      height: 32,
      margin: "0 0 4px 0",
    }}
  >
    {text && <FormattedMessage id={text} />}
  </Box>
);
export default DarkBar